module.exports = __webpack_public_path__ + "static/media/vlazhnost.42f8ac5a.pdf";